import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InfoGroup } from '../info-group/info-group.component';
import { InfoNavigation } from '../info-navigation/info-navigation.component';
import { getStoredUser } from '../helpers/user-storage.util';
import { ProjectService } from '../services/project.service';
import { AppService } from '../services/app.service';
import { SiteVisitConfirmationDialogComponent } from '../site-visit/site-visit-confirmation-dialog/site-visit-confirmation-dialog.component';
import { ModalService } from '../services/modal.service';

@Component({
  standalone: true,
  selector: 'info-active',
  imports: [
    CommonModule,
    InfoGroup,
    InfoNavigation,
    SiteVisitConfirmationDialogComponent,
  ],
  templateUrl: './active-page.component.html',
  styleUrl: './active-page.component.scss',
})
export class ActivePage {
  data: any = null;
  user = getStoredUser();
  loading: boolean = true;
  siteVisitConfirmationActive = false;

  constructor(
    private projectService: ProjectService,
    private modalService: ModalService,
    private appService: AppService
  ) {}

  ngOnInit() {
    this.fetchData();
    this.modalService.siteVisitConfirmationModalOpen.subscribe((isOpen) => {
      this.siteVisitConfirmationActive = isOpen;
    });
    this.appService.setRedirectUrl('');
  }

  fetchData() {
    this.projectService.fetchData(this.user.id ?? '').subscribe((result) => {
      this.data = result
        .map((parent: any) => ({
          ...parent,
          sites: parent.sites.filter(
            (child: any) =>
              child.proposal.status === 'ACTIVE' ||
              child.proposal.status === 'REVIEW_PENDING' ||
              child.proposal.status === 'REVISION_REQUESTED' ||
              child.proposal.status === 'REVISION_PENDING'
          ),
        }))
        .filter((parent: any) => parent.sites.length > 0 && parent.projectId);
      this.loading = false;
    });
  }

  toggleCloseSiteVisitConfirmationModal() {
    this.modalService.toggleCloseSiteVisitConfirmationModal();
  }
}
